// Rows of a table in groups by a label field of its view (R-E10, «События по статусам»): the terms in their order — of one pipeline when
// the view names it — each with its rows in the order of the query, then the rows without a value; empty groups are not shown.

import type { Id, MetaIndex, RecordObj, ViewDef } from '@confdeck/core-shared';
import type { TableGroup } from './DataTable.tsx';

export function tableGroups(meta: MetaIndex, record: (id: Id) => RecordObj | undefined, typeId: Id, groupBy: ViewDef['groupBy'], ids: readonly Id[]): TableGroup[] | undefined {
  const field = groupBy ? meta.field(typeId, groupBy.field) : undefined;
  if (!field || field.fieldType !== 'taxonomy') return undefined;
  const taxonomyId = field.options.taxonomyId as Id;
  const terms = groupBy!.pipelineId ? meta.children(groupBy!.pipelineId, taxonomyId) : [...meta.children(null, taxonomyId).flatMap((t) => [t, ...meta.children(t.id, taxonomyId)])];
  const by = new Map<string, Id[]>(terms.map((t) => [t.id, []]));
  const none: Id[] = [];
  for (const id of ids) {
    const v = record(id)?.data[field.key];
    const key = Array.isArray(v) ? v[0] : v;
    (typeof key === 'string' && by.get(key) || none).push(id);
  }
  const groups: TableGroup[] = terms.map((t) => ({ key: t.id, label: t.name, color: t.color, ids: by.get(t.id)! }));
  if (none.length) groups.push({ key: 'none', label: `Без значения «${field.name}»`, color: 'gray', ids: none });
  return groups.filter((g) => g.ids.length);
}
